import { mapGetters } from 'vuex'

export default {
  ...mapGetters('app/patient/agendas', [
    'loading',
    'agendas',
    'pagination',
    'searchedBy',
    'searchedByKeyword' // adcionando para teste de filtro de busca
  ])
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/search/results/resources/computed.js